import _ from 'lodash';
import i18n from '~/utils/i18n';
import { FILTER_TYPES } from '~/utils/constants';

export const toFilterFromToDate = value =>
  ((!_.isEmpty(value.from) && !_.isEmpty(value.to)) ? value : null);

export const availableFilters = [
  {
    name: 'created-at',
    slug: 'createdAt',
    type: FILTER_TYPES.DATE_FROM_TO,
    default: { from: null, to: null },
    getData: null,
    formatGetData: null,
    toObject: value => value,
    toFilter: toFilterFromToDate,
    translateFilter: () => i18n.t('campaign_field.title.created-at'),
  },
];

export function visibleFields(disabledFields, allFields) {
  disabledFields.forEach(item => {
    if (allFields[item]) {
      delete allFields[item];
    }
  });
  return allFields;
}



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/search-models/generic.js